import { render, staticRenderFns } from "./SendProductButton.vue?vue&type=template&id=85d573ca&"
import script from "./SendProductButton.vue?vue&type=script&lang=ts&"
export * from "./SendProductButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports